import { render, staticRenderFns } from "./widgetFwProtocolTrafTrend.vue?vue&type=template&id=3bd88dbe&scoped=true&"
import script from "./widgetFwProtocolTrafTrend.vue?vue&type=script&lang=js&"
export * from "./widgetFwProtocolTrafTrend.vue?vue&type=script&lang=js&"
import style0 from "./widgetFwProtocolTrafTrend.vue?vue&type=style&index=0&id=3bd88dbe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd88dbe",
  null
  
)

export default component.exports